import * as React from 'react';
import { Link } from 'react-router-dom';
import { IFooterProps } from '../../definitions/footer';

export default function FooterRender({ menu, warning }: IFooterProps) {
    if (!menu) {
        return null;
    }

    const links = !!menu && menu.map(({ name, link, external_link }) => (
        external_link ? (
            <a href={link} key={`link-${name}`} target="_blank" rel="noopener noreferrer">
                <span>{name}</span>
            </a>
        ) : (
            <Link to={`/${link}`} key={`link-${name}`}>
                <span>{name}</span>
            </Link>
        )
    ));

    return (
        <footer className="footer">
            <nav className="footer-nav">
                <div className="row">
                    <div className="container">
                        <div className="row center-xs">
                            {!!links && links.length > 0 && (
                                <div className="links">
                                    {links}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </nav>

            {warning && (
                <div className="warning-container">
                    <div className="container">
                        <div className="warning">
                            <p>
                                <span className="title">{warning.title}&nbsp;</span>
                                {warning.text}
                            </p>
                        </div>
                        {/* NOTE*: Leaving this here. Just in case it's needed to be included. */}
                        {/* <p className="disclaimer">
              *Offers valid while supplies last. Tabacalerausa.com is not
              responsible for typographical errors. WARNING:
              Tabacalerausa.com does not sell tobacco related products to
              anyone under the age of 21, nor do we sell cigarettes. Cigars
              and Tobacco products on this website are not intended to be
              purchased by anyone under the age of 21. All references to
              “mellow”, “medium”, “full” are only descriptors of flavor and
              not related to health. Flavor descriptors are not intended to
              convey health risks.
            </p> */}
                    </div>
                </div>
            )}

            <p className="copyright">
                &copy;2015-{new Date().getFullYear()} Tabacalerausa.com. All
                rights reserved.
            </p>
        </footer>
    );
}



// WEBPACK FOOTER //
// ./src/containers/Footer/render.tsx